import styled from 'styled-components';

export const Content = styled.div`
  width: 150px;
  height: 30px;
  background: #fff7df;
  border-radius: 5px 5px 0px 0px;
  border-left: 0.7rem solid #e3ae02;

  display: flex;
  align-items: center;

  p {
    margin-left: 8px;
    font-size: 0.9rem;
    line-height: 1rem;
    font-weight: 600;
  }

  button {
    border: 0;
    background: transparent;
  }
  img {
    margin-left: 10px;
    width: 20px;
    height: 18px;
  }
`;

export const SideBar = styled.aside`
  width: 8px;
  height: 30.2px;
  background: var(--region-percentage);
  border-radius: 5px 0 0 0;
`;
